var map = {
	"./avatar-1.jpg": 35902,
	"./avatar-2.jpg": 27401,
	"./avatar-3.jpg": 29612,
	"./avatar-4.jpg": 89847,
	"./avatar-5.jpg": 37914
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3743;